import SoundManager from "../../../../../lib/html5-software-library/src/ranj/audio/SoundManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import EmailAddedEvent from "../../email/model/EmailAddedEvent";
import EmailConversationStatusChangedEvent from "../../email/model/EmailConversationStatusChangedEvent";
import EmailInterfaceEvent from "../../email/model/EmailInterfaceEvent";
import EmailModel from "../../email/model/EmailModel";
import FileModelEvent from "../../files/event/FileModelEvent";
import FileModel from "../../files/model/FileModel";
import LaptopNavigateEvent from "../model/LaptopNavigateEvent";
import LaptopSoundType from "../sound/LaptopSoundType";

export default class LaptopOpenerMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {EmailModel} emailModel 
     * @param {FileModel} fileModel 
     * @param {SoundManager} soundManager 
     */
    constructor(target, dispatcher, emailModel, fileModel, soundManager) {
        super(target, dispatcher);

        this._emailModel = emailModel;
        this._fileModel = fileModel;
        this._soundManager = soundManager;
    }

    initialize() {
        super.initialize();

        this._button = this.createButton(this._target, this._handleButton.bind(this), "[Laptop]");

        this._updateUnreadItemsIndicator();

        this.registerEventListener(EmailAddedEvent.EMAIL_ADDED_TO_CONVERSATION, this._updateUnreadItemsIndicator.bind(this));
        this.registerEventListener(EmailConversationStatusChangedEvent.STATUS_CHANGED, this._updateUnreadItemsIndicator.bind(this));
        
        this.registerEventListener(FileModelEvent.FILE_ADDED, this._handleFileAdded.bind(this));
        this.registerEventListener(FileModelEvent.FILE_SEEN, this._updateUnreadItemsIndicator.bind(this));
        this.registerEventListener(FileModelEvent.FILE_REMOVED, this._updateUnreadItemsIndicator.bind(this));
    }

    destroy() {
        super.destroy();
    }

    _handleButton(evt) {
        this.dispatch(LaptopNavigateEvent.LAPTOP_SHOW_REQUEST);
        this.dispatch(EmailInterfaceEvent.UNLOCK_INTERFACE);
    }

    _handleFileAdded(evt) {
        this.playSound(LaptopSoundType.NEWFILE);
        this._updateUnreadItemsIndicator();
    }

    _updateUnreadItemsIndicator() {
        const unreadCount = this._emailModel.getUnreadCount() + this._fileModel.newFileCount;
        if (unreadCount > 0) {
            this._target.newIndicator.visible = true;
            this._target.newIndicator.newAmountTextField.text = unreadCount.toString();
        } else {
            this._target.newIndicator.visible = false;
        }
    }
}